import { defineStore } from "pinia";
import type User from "~/models/User";

export const useUser = defineStore("user", () => {
    const user:Ref<User|undefined> = ref();

    return  {user};
})
